import * as e from "react";
import { forwardRef as o } from "react";
import { c as t } from "./index.js-Cr0Rsuyz.mjs";
function a(r, l) {
  return /* @__PURE__ */ e.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: l
  }, r), /* @__PURE__ */ e.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.603 4.82a1.15 1.15 0 0 1 .045 1.626L9.395 12l5.253 5.554a1.15 1.15 0 0 1-1.67 1.58l-6-6.344a1.15 1.15 0 0 1 0-1.58l6-6.344a1.15 1.15 0 0 1 1.625-.045",
    clipRule: "evenodd"
  }));
}
var w = t(/* @__PURE__ */ o(a));
function i(r, l) {
  return /* @__PURE__ */ e.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: l
  }, r), /* @__PURE__ */ e.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.797 18.813a1.15 1.15 0 0 1 0-1.626L13.983 12 8.797 6.813a1.15 1.15 0 0 1 1.626-1.626l6 6c.449.449.449 1.177 0 1.626l-6 6a1.15 1.15 0 0 1-1.626 0",
    clipRule: "evenodd"
  }));
}
var f = t(/* @__PURE__ */ o(i));
export {
  w as I,
  f as a
};
